import { gql } from "generated-graphql";

export const NOTIFICATION_ROW_FRAGMENT = gql(`
  fragment NotificationRow on Notification {
    id
    message
  }
`);

export const GET_NOTIFICATIONS = gql(`
  query Notifications($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    notifications(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        message
        title
        bodyMarkdown
        category
        programArea
        priority
        invalidationKey
        resolvedAt
        createdAt
        tenant {
          id
          name
        }
        facility {
          id
          name
        }
        tierIIReport {
          id
          reportKind
          reportingYear
        }
      }
      count
    }
  }
`);

export const GET_MY_UNREAD_NOTIFICATION_COUNT = gql(`
  query MyUnreadNotificationCount($tenantId: ID) {
    myUnreadNotificationCount(tenantId: $tenantId)
  }
`);

export const GET_MY_NOTIFICATION_VIEWS = gql(`
  query MyNotificationViews($tenantId: ID) {
    myNotificationViews(tenantId: $tenantId) {
      needsAction
      aging
      unread
    }
  }
`);

export const GET_MY_NOTIFICATIONS = gql(`
  query MyNotifications(
    $tenantId: ID
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
    $includeArchived: Boolean
    $onlyUnread: Boolean
    $view: NotificationView
  ) {
    myNotifications(
      tenantId: $tenantId
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
      includeArchived: $includeArchived
      onlyUnread: $onlyUnread
      view: $view
    ) {
      items {
        id
        readAt
        archivedAt
        createdAt
        notification {
          id
          title
          bodyMarkdown
          category
          programArea
          priority
          resolvedAt
          createdAt
          tenant {
            id
            name
          }
          facility {
            id
            name
          }
          taskId
          jobId
          tierIIReportId
          submissionId
        }
      }
      count
    }
  }
`);

export const GET_NOTIFICATION_USER = gql(`
  query NotificationUser($id: ID!) {
    notificationUser(id: $id) {
      id
      readAt
      archivedAt
      createdAt
      notification {
        id
        title
        bodyMarkdown
        category
        programArea
        priority
        invalidationKey
        resolvedAt
        createdAt
        tenant {
          id
          name
        }
        facility {
          id
          name
        }
        taskId
        task {
          id
          seriesId
          tenantId
          title
          description
          status
          startDate
          endDate
          completedAt
          reminderDays
          frequency
          interval
          links
          assignee {
            id
            email
            person {
              first
              last
              email
            }
          }
          facilities {
            id
            name
          }
          watchers {
            id
            email
            person {
              first
              last
              email
            }
          }
          documents {
            id
            fileExtension
            title
            documentType
            sizeMegabytes
          }
          taskTags {
            id
            tag {
              id
              name
            }
          }
          subtasks {
            id
            title
          }
        }
        jobId
        job {
          id
          task
          status
          createdAt
          updatedAt
          facility {
            id
            name
          }
        }
        tierIIReportId
        tierIIReport {
          id
          reportKind
          reportingYear
        }
        submissionId
        submission {
          id
          title
          submissionType
          status
        }
      }
    }
  }
`);

export const MARK_NOTIFICATION_READ = gql(`
  mutation MarkNotificationRead($notificationUserId: ID!) {
    markNotificationRead(notificationUserId: $notificationUserId) {
      id
      readAt
    }
  }
`);

export const MARK_NOTIFICATION_UNREAD = gql(`
  mutation MarkNotificationUnread($notificationUserId: ID!) {
    markNotificationUnread(notificationUserId: $notificationUserId) {
      id
      readAt
    }
  }
`);

export const MARK_NOTIFICATIONS_READ = gql(`
  mutation MarkNotificationsRead($notificationUserIds: [ID!]!) {
    markNotificationsRead(notificationUserIds: $notificationUserIds)
  }
`);

export const MARK_NOTIFICATIONS_UNREAD = gql(`
  mutation MarkNotificationsUnread($notificationUserIds: [ID!]!) {
    markNotificationsUnread(notificationUserIds: $notificationUserIds)
  }
`);

export const ARCHIVE_NOTIFICATIONS = gql(`
  mutation ArchiveNotifications($notificationUserIds: [ID!]!) {
    archiveNotifications(notificationUserIds: $notificationUserIds)
  }
`);

export const MARK_ALL_NOTIFICATIONS_READ = gql(`
  mutation MarkAllNotificationsRead($tenantId: ID) {
    markAllNotificationsRead(tenantId: $tenantId)
  }
`);

export const MARK_ALL_NOTIFICATIONS_UNREAD = gql(`
  mutation MarkAllNotificationsUnread($tenantId: ID) {
    markAllNotificationsUnread(tenantId: $tenantId)
  }
`);

export const ARCHIVE_NOTIFICATION = gql(`
  mutation ArchiveNotification($notificationUserId: ID!) {
    archiveNotification(notificationUserId: $notificationUserId) {
      id
      archivedAt
      readAt
    }
  }
`);

export const QUEUE_STAFF_NOTIFICATION = gql(`
  mutation QueueStaffNotification($input: QueueStaffNotificationInput!) {
    queueStaffNotification(input: $input) {
      id
      title
      bodyMarkdown
      createdAt
    }
  }
`);

export const LINK_TASK_TO_NOTIFICATION = gql(`
  mutation LinkTaskToNotification($notificationId: ID!, $taskId: ID!) {
    linkTaskToNotification(notificationId: $notificationId, taskId: $taskId) {
      id
      taskId
    }
  }
`);

export const CREATE_TASK_FOR_NOTIFICATION = gql(`
  mutation CreateTaskForNotification($notificationId: ID!, $input: CreateTaskInput!) {
    createTaskForNotification(notificationId: $notificationId, input: $input) {
      id
      taskId
    }
  }
`);

export const GENERATE_SCOUT_TEST_NOTIFICATION = gql(`
  mutation GenerateScoutTestNotification($input: GenerateScoutTestNotificationInput!) {
    generateScoutTestNotification(input: $input) {
      id
      title
      bodyMarkdown
      category
      programArea
      priority
      createdAt
      facility {
        id
        name
      }
    }
  }
`);
